<template>
  <v-container fluid id="fcreate">
    <breadcrumbs/>
    <h1 class="mb-2">
      Редактирование СЕО записи
    </h1>
    <v-row>
      <v-form v-model="valid" ref="form">
        <v-container fluid>
          <v-row>
            <!-- Название -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.name"
                label="Название"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- URL -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.url"
                label="Адрес страницы без домена"
                outlined
                required
                :rules="rules.required"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Регион -->
            <v-col cols="12" md="7">
              <v-autocomplete
                v-model="data.regionId"
                :items="regions"
                item-text="name"
                item-value="id"
                label="Регион"
                clearable
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- metaTitle -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.metaTitle"
                label="Meta title"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- metaDescription -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.metaDescription"
                rows="4"
                label="Meta description"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- pageTitle -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.pageTitle"
                label="Заголовок страницы (h1)"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Текст -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.text"
                rows="10"
                label="Текст"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Статус -->
            <v-col cols="12" md="7">
              <v-checkbox
                v-model="data.status"
                label="Активно"
                outlined
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Submit -->
            <v-col cols="12" md="7">
              <v-row>
                <v-col cols="4">
                  <v-btn
                    class="mb-2"
                    block
                    large
                    color="success"
                    :loading="loadingForm"
                    :disabled="loadingForm"
                    @click.prevent="save"
                  >
                    Сохранить
                  </v-btn>
                </v-col>
                <v-col cols="4">
                  <v-btn
                    class="mb-2"
                    block
                    large
                    color="info"
                    :loading="loadingForm"
                    :disabled="loadingForm"
                    @click.prevent="save(false)"
                  >
                    Применить
                  </v-btn>
                </v-col>
                <v-col cols="4">
                  <v-btn
                    block
                    large
                    color="error"
                    :loading="loading"
                    :disabled="loading"
                    @click.prevent="$router.back()"
                  >
                    Отменить
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-row>
    <v-snackbar v-model="snackbar">
      Исправьте ошибки и повторите попытку
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="snackbarSuccess">
      Измемнения сохранены
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import rules from '@/mixins/rules'
  import snackbarMessage from '@/mixins/snackbar-message'
  import { mapGetters } from 'vuex'

  export default {
    mixins: [rules, snackbarMessage],
    data () {
      return {
        data: {
          name: null,
          metaDescription: null,
          metaTitle: null,
          pageTitle: null,
          regionId: null,
          status: true,
          text: null,
          url: null,
        },
        valid: false,
        loading: false,
        loadingForm: false,
        snackbar: false,
        snackbarSuccess: false,
      }
    },
    computed: {
      ...mapGetters({
        regions: 'regions/getRegions',
      }),
      getId () { return this.$route.params.id },
    },
    async created () {
      this.loading = true
      try {
        this.data = await this.$store.dispatch('seo/fetchSinglePageMeta', this.getId)
      } catch (err) {
        this.showErrorFromResponse(err)
      }
      await this.$store.dispatch('regions/fetchRegions')
      this.loading = false
    },
    methods: {
      async save (redirect = true) {
        const validate = this.$refs.form.validate()

        if (validate) {
          this.loadingForm = true

          try {
            const data = this.data

            await this.$store.dispatch('seo/editPageMeta', {
              data: data,
              id: this.getId,
            })
            if (redirect) {
              this.$router.push({ name: 'seoPageMetaList' })
            }
          } catch (err) {
            this.showErrorFromResponse(err)
          }

          this.loadingForm = false
        } else {
          this.snackbar = true
          setTimeout(() => {
            this.snackbar = false
          }, 3000)
          document.getElementById('fcreate').scrollIntoView({
            behavior: 'smooth',
          })
        }
      },
    },
  }
</script>
